import types from '../types'

const initialState = {
  saveWrapUp: {
    loading: false,
    error: false,
    success: false
  },
  createAppointment: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  createDocument: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  saveS2K: {
    loading: false,
    error: false,
    success: false,
    data: []
  },
  orders: []
}

const wrapUpReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.SET_WRAP_UP: {
    const { opportunities, rules, actions } = action.payload
    return {
      ...state,
      opportunities,
      rules,
      actions: actions.map((action) => ({
        ...action,
        checked: true
      }))
    }
  }
  case types.SAVE_WRAP_UP_REQUESTED: {
    return {
      ...state,
      saveWrapUp: {
        loading: true,
        error: false,
        success: false
      }
    }
  }
  case types.SAVE_WRAP_UP_FULFILLED: {
    return {
      ...state,
      saveWrapUp: {
        ...state.saveWrapUp,
        loading: false,
        success: true
      }
    }
  }
  case types.SAVE_WRAP_UP_REJECTED: {
    return {
      ...state,
      saveWrapUp: {
        ...state.saveWrapUp,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.CLEAR_WRAP_UP: {
    return {
      ...state,
      actions: state.actions.map((action) => ({
        ...action,
        checked: false
      }))
    }
  }
  case types.CREATE_APPOINTMENT_REQUESTED: {
    return {
      ...state,
      createAppointment: {
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
  }
  case types.CREATE_APPOINTMENT_FULFILLED: {
    return {
      ...state,
      createAppointment: {
        ...state.createAppointment,
        loading: false,
        success: true,
        data: action.payload
      }
    }
  }
  case types.CREATE_APPOINTMENT_REJECTED: {
    return {
      ...state,
      createAppointment: {
        ...state.createAppointment,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.CREATE_DOCUMENT_REQUESTED: {
    return {
      ...state,
      createDocument: {
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
  }
  case types.CREATE_DOCUMENT_FULFILLED: {
    return {
      ...state,
      createDocument: {
        ...state.createDocument,
        loading: false,
        success: true,
        data: action.payload
      }
    }
  }
  case types.CREATE_DOCUMENT_REJECTED: {
    return {
      ...state,
      createDocument: {
        ...state.createDocument,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.SAVE_S2K_REQUESTED: {
    return {
      ...state,
      saveS2K: {
        loading: true,
        error: false,
        success: false,
        data: []
      }
    }
  }
  case types.SAVE_S2K_FULFILLED: {
    return {
      ...state,
      saveS2K: {
        ...state.saveS2K,
        loading: false,
        success: true,
        data: action.payload
      }
    }
  }
  case types.SAVE_S2K_REJECTED: {
    return {
      ...state,
      saveS2K: {
        ...state.saveS2K,
        loading: false,
        error: action.payload
      }
    }
  }
  case types.SET_ORDERS: {
    return {
      ...state,
      orders: action.payload
    }
  }
  default:
    return state
  }
}

export default wrapUpReducer
